import logoImage from '../../assets/19dee11c3f5573d979f66c4dfc6f495d5d83dfc9.png'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  showText?: boolean
  textSize?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeClasses = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
  xl: 'w-16 h-16',
}

const textSizeClasses = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg',
}

export function Logo({ size = 'md', showText = true, textSize = 'md', className = '' }: LogoProps) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src={logoImage}
        alt="PocketBloom Logo"
        className={`${sizeClasses[size]} object-contain`}
      />
      {showText && (
        <div>
          <h2 className={`font-semibold text-gray-900 ${textSizeClasses[textSize]}`}>
            PocketBloom
          </h2>
          <p className="text-xs text-gray-500">Gül çatdırılması</p>
        </div>
      )}
    </div>
  )
}

export function LogoIcon({
  size = 'md',
  className = '',
}: {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}) {
  return (
    <img
      src={logoImage}
      alt="PocketBloom"
      className={`${sizeClasses[size]} object-contain ${className}`}
    />
  )
}

